export default __webpack_public_path__ + "static/media/do-1@2x.56f63a0d.jpg";